<template>
  <button :class="['bg-blue-600 shadow-lg shadow-blue-600 hover:scale-105 active:scale-95 p-4 rounded-md']">
    <a href="https://api.whatsapp.com/send?phone=5546991166942&text=Ol%C3%A1%2C%20venho%20atrav%C3%A9s%20da%20p%C3%A1gina%20e%20gostaria%20de%20agendar%20uma%20pr%C3%A9-consulta%C2%A0gratuita" class="flex justify-center w-full items-center gap-x-4" target="_blank" rel="noopener noreferrer" :title="title">
      <span class="text-xl text-white">{{ title }}</span>
      <slot></slot>
    </a>
  </button>

</template>
<script>
export default {
  name: 'PrimaryButton',
  props: {
    title: {
      type: String,
      required: true
    },
  }
}
</script>